import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Type, useToken } from '@lendi/lala-react';

import { CustomerContext } from '@funnels/contexts';
import { fetchCustomerMe } from '@funnels/redux-store';
import { ClientCustomer, ReduxStoreData } from '@funnels/types';
import { datadogUtil, getViewType, initialFormValues } from '@funnels/utils';

interface CustomerProviderProps {
  children: React.ReactNode;
}

function mapState(currentState: ReduxStoreData) {
  const customer = currentState.customers.data[0] || initialFormValues.INITIAL_CUSTOMER();

  return { customer };
}

function CustomerProvider(props: CustomerProviderProps) {
  const { customer } = useSelector(mapState);
  // const { [URL_PARAM_APPLICATION_ID]: applicationId } = useParams<UseParams>();
  const [customerContextData, setCustomerData] = useState<ClientCustomer>({ data: customer, isFetching: false });
  const dispatch = useDispatch();
  const token = useToken();
  const viewType = getViewType();

  const getCustomerData = useCallback(async () => {
    if (!token || viewType === Type.Team || !!localStorage.getItem('_lendi_funnels_debug_bypass_auth')) {
      return;
    }

    setCustomerData({ ...customerContextData, isFetching: true });
    dispatch(fetchCustomerMe());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    getCustomerData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    const { id } = customer;

    setCustomerData({ data: customer, isFetching: false });
    datadogUtil.setUser({ id });
  }, [customer]);

  return <CustomerContext.Provider value={customerContextData}>{props.children}</CustomerContext.Provider>;
}

export default CustomerProvider;
